module.exports = __webpack_public_path__ + "files/b2d7b50383c3e5c9538f9e67fef0e51b.png";